import { Box } from '@chakra-ui/react'
import { ContentNode, ListContentNode } from '@helo/cms'

import { ListContentNodeParts } from '../../datatypes/list/listContentNode.parts'
import { createWidget } from '../widget-utils'
import {
  MilestoneListSkeleton,
  MilestoneParts,
  MilestoneRow,
} from './MilestoneWidget.parts'
import { MilestoneLayout, type MilestoneVariant } from './milestone.constants'

export interface MilestoneWidgetProps {
  milestones?: ListContentNode
  isLoading?: boolean
  /**
   * Preset visibility/layout defaults. Explicit hide* props override the variant.
   */
  variant?: MilestoneVariant
  /**
   * Parent-level shipment document id (e.g. container details page).
   * Used when milestone rows do not embed ShipmentDocument.
   */
  shipmentDocumentId?: ContentNode
  hideShipmentDocumentId?: boolean
  hideIssuer?: boolean
}

export const MilestoneWidget = ({
  milestones: milestonesListContentNode,
  isLoading,
  variant,
  shipmentDocumentId,
  hideShipmentDocumentId,
  hideIssuer,
  ...boxProps
}: MilestoneWidgetProps) => {
  const display = MilestoneParts.resolveDisplayOptions({
    variant,
    hideShipmentDocumentId,
    hideIssuer,
  })

  if (
    isLoading ||
    !milestonesListContentNode ||
    ListContentNodeParts.isListPending(milestonesListContentNode, isLoading)
  ) {
    return <MilestoneListSkeleton display={display} />
  }

  const milestones =
    ListContentNodeParts.resolveListItemData(milestonesListContentNode) ?? []
  return (
    <Box {...boxProps} {...MilestoneLayout.root()}>
      {milestones.map((milestoneContentNode, index) => (
        <MilestoneRow
          key={index}
          milestoneContentNode={milestoneContentNode as ContentNode}
          index={index}
          total={milestones.length}
          parentShipmentDocumentId={shipmentDocumentId}
          display={display}
        />
      ))}
    </Box>
  )
}

export const MilestoneWidgetDefinition = createWidget(MilestoneWidget, {
  type: 'Milestone',
})
